<div class="sample-errors-page" [class.print-view]="isPrintView" [class.print-mode]="isPrintMode" *ngIf="vm$ | async as vm">
  @if (isPrintView) {
  <app-print-preview-bar
    viewName="Sample Errors"
    [studyName]="vm.studyName"
    [contextLine]="vm.printContext"
    [tableColumns]="vm.tableColumns"
    (selectColumns)="handleSelectColumns($event)"></app-print-preview-bar>
  }

  <!--
    The printed document is unchanged: the run-out of labels below is what has always gone to
    paper. On screen the same values read as the identification card the other tabs use.
  -->
  @if (isPrintView) {
  <div class="bpx-print-only">
    <div class="meta-block">
      <div class="meta-row">Panel Name: <span id="panel-name">{{ vm.panelName }}</span></div>
      <div class="meta-row">Run Type: <span id="run-type">{{ vm.runType }}</span></div>
      <div class="meta-row">Test Spec: <span id="test-spec">{{ vm.testSpec }}</span></div>
      <div class="meta-row">Assignment Spec: <span id="assignment-spec">{{ vm.assignmentSpec }}</span></div>
      <div class="meta-row">Operator: <span id="operator">{{ vm.operator }}</span></div>
    </div>
  </div>

  <div class="bpx-detail bpx-screen-only">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value">{{ vm.panelName }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value">{{ vm.runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value">{{ vm.testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value">{{ vm.assignmentSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value">{{ vm.operator }}</span>
    </div>
  </div>
  }

  @if (!isPrintView) {
  <div class="bpx-detail">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Panel Name</span>
      <span class="bpx-detail__value" id="panel-name">{{ vm.panelName }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Run Type</span>
      <span class="bpx-detail__value" id="run-type">{{ vm.runType }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Test Spec</span>
      <span class="bpx-detail__value" id="test-spec">{{ vm.testSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Assignment Spec</span>
      <span class="bpx-detail__value" id="assignment-spec">{{ vm.assignmentSpec }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Operator</span>
      <span class="bpx-detail__value" id="operator">{{ vm.operator }}</span>
    </div>
  </div>

  <div class="bpx-toolbar__actions">
    <a (click)="navigateToPrintView()" class="bpx-btn"
      [class.bpx-btn--disabled]="(isStudySaved$ | async) !== true"
      [attr.aria-disabled]="(isStudySaved$ | async) !== true"
      [style.pointer-events]="((isStudySaved$ | async) !== true) ? 'none' : null">
      <mat-icon fontIcon="print"></mat-icon>Print View
    </a>
  </div>
  }

  <p class="bpx-empty bpx-empty--page" *ngIf="!vm.hasCalculation">
    Run a calculation to view sample errors.
  </p>

  <p class="bpx-empty bpx-empty--page" *ngIf="vm.hasCalculation && !vm.hasSampleErrors">
    No sample errors were reported for the current calculation.
  </p>

  <div class="bpx-report table-wrap" *ngIf="vm.rows.length > 0">
    @if (isPrintView && isPrintMode) {
    @for (pageColumns of vm.printPages; track pageColumns; let pageIndex = $index) {
    <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (vm.printPages.length - 1)">
      @if (printPageCaption(pageIndex, vm.printPages)) {
      <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex, vm.printPages) }}</div>
      }
      <ng-container *ngTemplateOutlet="sampleErrorsTableTpl; context: { pageColumns: pageColumns, pageRows: getPageRows(vm.rows, vm.columns, pageColumns) }"></ng-container>
    </div>
    }
    } @else {
    <ng-container *ngTemplateOutlet="sampleErrorsTableTpl; context: { pageColumns: vm.columns, pageRows: vm.rows }"></ng-container>
    }

    <ng-template #sampleErrorsTableTpl let-pageColumns="pageColumns" let-pageRows="pageRows">
      <table class="bpx-report__table bpx-report__table--pin-first sample-errors-table" [class.sample-errors-print]="isPrintMode">
        <tbody>
          <tr class="bpx-report__head">
            <td class="label-cell">KitLot#</td>
            <td *ngFor="let column of pageColumns" [class.selected-kit-highlight]="column.isRefKitLot">{{ column.kitLot }}</td>
          </tr>
          <tr class="bpx-report__head">
            <td class="label-cell">Instrument ID</td>
            <td *ngFor="let column of pageColumns" [class.selected-kit-highlight]="column.isRefKitLot">{{ column.runId }}</td>
          </tr>
          <tr class="bpx-report__head">
            <td class="label-cell">Assay Name</td>
            <td *ngFor="let column of pageColumns" [class.selected-kit-highlight]="column.isRefKitLot">{{ column.assay }}</td>
          </tr>
          <tr class="bpx-report__head">
            <td class="label-cell">Bead Region</td>
            <td *ngFor="let column of pageColumns" [class.selected-kit-highlight]="column.isRefKitLot">{{ column.beadRegion }}</td>
          </tr>
          <tr class="section-header bpx-report__section">
            <td>Sample ID</td>
            <td [attr.colspan]="pageColumns.length"></td>
          </tr>
          <tr *ngFor="let row of pageRows">
            <td class="label-cell">{{ row.sampleId }}</td>
            <td *ngFor="let value of row.values" [class.assay-failure-text]="value.isAssayFailure">
              @if (isPrintMode && value.isErrorMessage) {
                <div class="error-message print-error-message">
                  <div class="print-error-line" *ngFor="let line of getPrintErrorLines(value.fullMessage || value.text)">
                    {{ line }}
                  </div>
                </div>
              } @else if (value.isErrorMessage) {
                <span
                  class="error-message"
                  [class.error-message--clickable]="value.isErrorMessage"
                  (click)="openErrorDialog(value.fullMessage)">
                  {{ value.text }}
                </span>
              } @else {
                {{ value.text }}
              }
            </td>
          </tr>
        </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="(pageColumns.length || 0) + 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
      </table>
    </ng-template>
  </div>

  @if (isPrintMode) {
  <div class="header">
    Bio-Rad Laboratories<br />
    Redmond, WA
  </div>
  <div class="print-footer-cutoff" aria-hidden="true"></div>
  <div class="footer">
    <div class="print-footer-left">
      {{ vm.studyName || '-' }}<br />
      {{ vm.panelName || '-' }} : Spec Rev {{ vm.specVersion || '-' }}<br />
      Web App Version: {{ vm.appVersion || '-' }}
    </div>
  </div>
  }
</div>
